import { defineMessages } from '@formatjs/intl';

export default defineMessages({
	signupTitle: {
		id: 'signup.accountSetup.title',
		defaultMessage: 'Create a free account to save your preferences',
		description: 'The title for the Calm signup component',
	},
});
